const SuccessModal = {
    element: null,

    show: function (title, message, buttonText = "TAMAM", onConfirm = null) {
        this.render(title, message, buttonText, onConfirm);
    },

    hide: function () {
        if (this.element) {
            // Animasyonlu çıkış
            this.element.style.opacity = '0';
            setTimeout(() => {
                if (this.element) this.element.remove();
                this.element = null;
            }, 300);
        }
    },

    render: function (title, message, buttonText, onConfirm) {
        if (this.element) this.element.remove();

        const modal = document.createElement('div');
        Object.assign(modal.style, {
            position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(10px)',
            display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: '25000',
            fontFamily: "'Outfit', sans-serif", opacity: '0', transition: 'opacity 0.3s ease'
        });

        const card = document.createElement('div');
        Object.assign(card.style, {
            background: 'linear-gradient(145deg, #1a1a1a, #0d0d0d)',
            padding: '40px', borderRadius: '25px',
            border: '2px solid var(--accent-gold)',
            width: 'min(450px, 90%)',
            boxShadow: '0 0 50px rgba(255, 215, 0, 0.15), 0 0 20px rgba(0,0,0,0.8)',
            textAlign: 'center', position: 'relative', transform: 'scale(0.9)', transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
        });

        // Icon
        const iconDiv = document.createElement('div');
        iconDiv.innerHTML = '🎉'; // Alternatif: ✨, 🚀
        Object.assign(iconDiv.style, {
            fontSize: '4rem', marginBottom: '15px',
            textShadow: '0 0 20px rgba(255,215,0,0.6)'
        });
        card.appendChild(iconDiv);

        // Title
        const titleEl = document.createElement('h2');
        titleEl.innerText = title;
        Object.assign(titleEl.style, {
            color: 'var(--accent-gold)', marginBottom: '15px',
            fontSize: '2rem', fontFamily: "'Cinzel', serif", fontWeight: '700',
            textTransform: 'uppercase', letterSpacing: '1px'
        });
        card.appendChild(titleEl);

        // Message
        const msgEl = document.createElement('p');
        msgEl.innerHTML = message;
        Object.assign(msgEl.style, {
            color: '#e0e0e0', marginBottom: '30px',
            fontSize: '1.1rem', lineHeight: '1.6'
        });
        card.appendChild(msgEl);

        // Button
        const btn = document.createElement('button');
        btn.innerText = buttonText;
        Object.assign(btn.style, {
            padding: '15px 40px', borderRadius: '50px',
            border: 'none', background: 'var(--accent-gold)', color: '#000',
            fontWeight: '900', fontSize: '1.1rem', cursor: 'pointer',
            transition: 'all 0.2s', boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)'
        });

        btn.onmouseover = () => {
            btn.style.transform = 'translateY(-2px) scale(1.05)';
            btn.style.boxShadow = '0 6px 20px rgba(255, 215, 0, 0.5)';
        };
        btn.onmouseout = () => {
            btn.style.transform = 'translateY(0) scale(1)';
            btn.style.boxShadow = '0 4px 15px rgba(255, 215, 0, 0.3)';
        };

        btn.onclick = () => {
            if (onConfirm) onConfirm();
            this.hide();
        };

        card.appendChild(btn);
        modal.appendChild(card);
        document.body.appendChild(modal);
        this.element = modal;

        // Intro Animation
        requestAnimationFrame(() => {
            modal.style.opacity = '1';
            card.style.transform = 'scale(1)';
        });
    }
};

window.SuccessModal = SuccessModal;
